import { render, staticRenderFns } from "./BaseConocimiento.vue?vue&type=template&id=6ea202ec&scoped=true"
import script from "./BaseConocimiento.vue?vue&type=script&lang=js"
export * from "./BaseConocimiento.vue?vue&type=script&lang=js"
import style0 from "./BaseConocimiento.vue?vue&type=style&index=0&id=6ea202ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea202ec",
  null
  
)

export default component.exports